import { useMediaQuery } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from '@emotion/styled';

import { StyledAccountLayoutTitle } from '../feature/account-layout';
import { AddPlan } from './add-plan';

const StyledTabInfoContainer = styled('div')(({ theme }: { theme?: any }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(4),
}));

interface Props {
  theme: any;
  name: string;
  isOverview: boolean;
}

export const AccountTabInfo = withTheme(
  ({ theme, name, isOverview }: Props) => {
    const matchesMd = useMediaQuery(theme.breakpoints.down('md'));

    if (matchesMd) return null;

    return (
      <StyledTabInfoContainer>
        <StyledAccountLayoutTitle as="p" className="secondary-header" isSmall>
          {name}
        </StyledAccountLayoutTitle>
        {isOverview && <AddPlan />}
      </StyledTabInfoContainer>
    );
  }
);
